module.exports = __webpack_public_path__ + "static/media/video-2-cover.88b0d27f.png";